export enum ContactStatus {
    Invited = 'invited',
    Active = 'active',
    Blocked = 'blocked',
}